<template>
  <div>
    <div style="width: 100%; height: 160px; background: red;"></div>
    <div style="display: flex;">
      <div style="width: 200px; height: 800px; background-color: aqua;">
        <div @click="handleCreate">创建</div>
        <div @click="modelList">模版列表</div>
      </div>
      <div style="width: calc(100% - 200px); height: auto;">
        <router-view />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {

    };
  },
  methods: {
    handleCreate() {
      this.$router.push({ path: '/create' });
    },
    modelList() {
      this.$router.push({ path: '/HomePage' });
    }
  }
}
</script>

<style scoped></style>


// WEBPACK FOOTER //
// src/views/MainPage/index.vue